import { Component, OnInit } from '@angular/core';
import { BonusService } from 'src/app/services/bonus/bonus.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';

@Component({
  selector: 'app-risk-free-bet-risk',
  templateUrl: './risk-free-bet-risk.component.html',
  styleUrls: ['./risk-free-bet-risk.component.scss'],
})
export class RiskFreeBetRiskComponent implements OnInit {

  constructor(
    private bonusService: BonusService,
    private events: EventsService,
    private successMessageService: SuccessMessageService,

  ) {
    this.successMessageService.clearMessage();
  }

  ngOnInit() { }

}
